import { useNavigate } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import { Badge } from "../../../components/Badge";
import ActionIcon from "../../../components/ActionIcon";
import SaveItemSVG from "../../../assets/Icons/SaveItem";
import { useState } from "react";
import { api } from "../../../api";
import { FavoriteProjectsIds } from "../../../types";

interface TitleSectionProps {
  id: number;
  name: string;
  status: string;
  isSaved: boolean;
}

const TitleSection = ({ id, name, status, isSaved }: TitleSectionProps) => {
  const navigate = useNavigate();
  const [itemSaved, setItemSaved] = useState<boolean>(isSaved);

  const handleSaveItem = () => {
    if (itemSaved) {
      unSaveProject();
    } else {
      saveProject();
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  const saveProject = async () => {
    const body = {
      current_project: id,
    };
    const saveStatus = await api
      .post<FavoriteProjectsIds>("/user/favourites", body)
      .then((savedList) => savedList.data.current_projects.includes(id));
    setItemSaved(saveStatus);
  };

  const unSaveProject = async () => {
    const saveStatus = await api
      .delete<FavoriteProjectsIds>("/user/favourites/current_projects/" + id)
      .then((savedList) => savedList.data.current_projects.includes(id));
    setItemSaved(saveStatus);
  };

  // fix this shit in near future
  return (
    <div className="flex w-full items-center justify-between gap-4">
      <div className="space-x-2">
        <button onClick={goBack} className="focus:outline-none">
          <IoArrowBackSharp className="text-primaryPurple-100" />
        </button>
        <span className="text-xl font-medium text-black">{name}</span>
        <Badge>{status}</Badge>
      </div>
      <ActionIcon
        className={`flex h-10 w-10 items-center justify-center rounded-full border-0 p-2 shadow-md ${
          itemSaved ? "bg-blue-400" : ""
        }`}
        variant="outlined"
        onClick={handleSaveItem}
        icon={<SaveItemSVG fill={itemSaved ? "white" : ""} />}
      />
    </div>
  );
};

export default TitleSection;
